<section>
  <div class="flex justify-between items-end">
    <div>
      <h1>Students</h1>
    </div>
    <div class="flex items-center gap-3">
      <div class="dropdown dropdown-bottom dropdown-end">
        <div tabindex="0" role="button" class="btn btn-sm btn-primary border flex items-center">
          Action <i class="ri-arrow-down-s-line"></i>
        </div>
        <ul tabindex="0"
          class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow mt-2 text-sm font-semibold">
          <li><a>Assign Courses</a></li>
          <li><a>Activity log</a></li>
          <li><a>Chat</a></li>
          <li><a>Delete Student</a></li>
        </ul>
      </div>

      <div class="dropdown dropdown-bottom dropdown-end">
        <div tabindex="0" role="button" class="btn btn-sm bg-white border flex items-center">
          Filter <i class="ri-filter-3-line"></i>
        </div>

        <ul tabindex="0"
          class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow mt-2 text-sm font-semibold">
          <li><a>this Month</a></li>
          <li><a>acedemic Year</a></li>
          <li><a>calender year</a></li>
          <li><a>lifetime</a></li>
          <li><a>custom</a></li>
        </ul>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-3 gap-5 mt-5">
    <!-- student Details -->
    <div class="col-span-1">
        <app-staff-student-common-profile-view [isStudent]="true"  [profileData]="studentProfileData"></app-staff-student-common-profile-view>
    </div>
    <!-- student Details -->
    <!-- analytics cards -->
    <div class="col-span-2">

      <div class="flex justify-between items-end ">
      <div class="max-w-md ">
        <div role="tablist" class="tabs border tabs-boxed gap-1">
          @for (i of tabs; track $index) {
            <a role="tab" class="tab capitalize" [ngClass]="{'tab-active': currentTab === i.value}" (click)="currentTab = i.value">{{i.name}}</a>
          }
          </div>
      </div>

      <div class="flex items-center justify-end rounded-lg gap-3 p-1 ">
        <span class="text-sm font-semibold">Courses :</span>
        <select class="select select-sm select-bordered w-[13rem]">
          <option disabled selected>Course 1</option>
          <option>Course 2</option>
          <option>Course 3</option>
          <option>Course 4</option>
          <option>Course 5</option>
        </select>
      </div>
    </div>



    <!-- reports -->
    <div class="my-5">

      <ng-container [ngSwitch]="currentTab">
        <app-video-report *ngSwitchCase="'video'"></app-video-report>
        <app-flashcard-report *ngSwitchCase="'flashcard'"></app-flashcard-report>
        <app-tests-report *ngSwitchCase="'ai-test'"></app-tests-report>
      </ng-container>

    </div>



    </div>
    <!-- analytics cards -->
  </div>
</section>